var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOpenAction = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42586E",
    fillRule: "evenodd",
    d: "M15.833 13.669l-5 1.123v-8.46l5-1.123v8.46zM4.167 5.209l5 1.122v8.461l-5-1.123v-8.46zm13.02-1.694c-.198-.157-.456-.217-.704-.161L10 4.81 3.517 3.354c-.249-.057-.506.004-.704.161-.198.16-.313.399-.313.652v10.168c0 .39.27.728.65.813l6.667 1.498c.061.014.122.021.183.021.06 0 .122-.007.183-.02l6.667-1.499c.38-.085.65-.422.65-.813V4.168c0-.253-.115-.492-.313-.652z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenAction, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/open_action.78a5d8e0.svg";
export { ForwardRef as ReactComponent };